import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Lightbulb, Brain } from 'lucide-react';
export function RevelationSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="bg-gradient-to-b from-slate-900 to-slate-800 text-white py-16 px-4" data-id="element-181">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-182">
        <div className="flex items-center justify-center mb-6" data-id="element-183">
          <Lightbulb className="w-12 h-12 text-amber-400" data-id="element-184" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8" data-id="element-185">
          The <span className="text-orange-400" data-id="element-186">Truth</span> They Don't Tell You
        </h2>
        <p className="text-lg md:text-xl text-slate-300 leading-relaxed mb-6" data-id="element-187">
          Most trainers tell you to "just let them cry it out." In 2026, we know
          that's the{' '}
          <span className="font-semibold text-white" data-id="element-188">
            worst thing you can do
          </span>
          . It floods your dog's brain with cortisol, creating permanent trauma.
        </p>
        <div className="bg-slate-800 border-l-4 border-orange-500 p-6 rounded-lg mb-6" data-id="element-189">
          <div className="flex items-start gap-4" data-id="element-190">
            <Brain className="w-8 h-8 text-orange-400 flex-shrink-0 mt-1" data-id="element-191" />
            <div data-id="element-192">
              <p className="text-xl md:text-2xl font-semibold mb-3" data-id="element-193">
                The secret isn't more exercise—it's{' '}
                <span className="text-orange-400" data-id="element-194">
                  Biological Trigger Neutralization
                </span>
                .
              </p>
              <p className="text-lg text-slate-300" data-id="element-195">
                By spending just 15 minutes a day "re-wiring" how your dog
                perceives your departure, you can flip the switch from Panic to
                Peace.
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}